// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { MDBBtn } from "mdb-react-ui-kit";
// import axiosInstance from "../utilities/apiConfig";
// import Loader from "../components/Loader";
// import barLogo from "../assets/images/BarAssociationDeharadunLogo.png";
// import dummyProfileImage from "../assets/images/dummyPhoto.png";
// import dummySignature from "../assets/images/dummySignature.png";
// import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
// import "../styles/feesSlip.css";

// // Printable Membership Fees Slip. Same layout as the FeesSlip.aspx report,
// // but rendered in-app with data from /LoginFees/get_fees_slip_print.
// const FeesSlip = () => {
//   const { barId } = useParams(); // underscore format, e.g. "UK 1486_22"
//   const navigate = useNavigate();
//   const token = useSelector((state) => state.auth.token);

//   const [loading, setLoading] = useState(true);
//   const [slip, setSlip] = useState(null);
//   const [photo, setPhoto] = useState(dummyProfileImage);
//   const [signature, setSignature] = useState(dummySignature);
//   const [fingerprint, setFingerprint] = useState(dummyFingerprint);

//   // e.g. "Son" / "S/O" -> "Son of"
//   const relationshipLabel = (relationshipType) => {
//     const value = (relationshipType || "").toLowerCase();
//     if (value.includes("s")) return "Son of";
//     if (value.includes("d")) return "Daughter of";
//     if (value.includes("w")) return "Wife of";
//     return "Relative of";
//   };

//   // Loads an image through the File controller view apis
//   // (/File/view_photo, /File/view_signature, /File/view_fingerprint).
//   // slip paths come as "Photo/abc.png" — only the file name is needed here.
//   const fetchImage = async (viewApi, relativePath, setImage, fallback) => {
//     const fileName = (relativePath || "").split("/").pop();
//     if (!fileName) {
//       setImage(fallback);
//       return;
//     }
//     try {
//       const response = await axiosInstance.get(
//         `/File/${viewApi}/${encodeURIComponent(fileName)}`,
//         {
//           responseType: "blob",
//         }
//       );
//       setImage(URL.createObjectURL(response.data));
//     } catch (error) {
//       console.error("Error fetching slip image:", relativePath, error);
//       setImage(fallback);
//     }
//   };

//   useEffect(() => {
//     const fetchSlipData = async () => {
//       try {
//         setLoading(true);
//         const response = await axiosInstance.get(
//           `/LoginFees/get_fees_slip_print/${barId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         console.log("Fees slip response", response.data);

//         if (response.data?.statusCode === 200 && response.data?.slip) {
//           const slipData = response.data.slip;
//           setSlip(slipData);
//           fetchImage("view_photo", slipData.photo, setPhoto, dummyProfileImage);
//           fetchImage(
//             "view_signature",
//             slipData.signature,
//             setSignature,
//             dummySignature
//           );
//           fetchImage(
//             "view_fingerprint",
//             slipData.fingerprintImage,
//             setFingerprint,
//             dummyFingerprint
//           );
//         } else {
//           toast.error(response.data?.status || "Could not load fees slip");
//         }
//       } catch (error) {
//         console.error("Error loading fees slip", error);
//         if (error.response?.status === 401) {
//           toast.error("Session expired. Please login again.");
//         } else if (error.response?.status === 404) {
//           toast.error("No fees record found for this bar id.");
//         } else {
//           toast.error("Could not load fees slip");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSlipData();
//   }, [barId, token]);

//   const printDate = new Date().toLocaleString("en-GB", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: true,
//   });

//   const amountText =
//     slip?.feesAmount !== null && slip?.feesAmount !== undefined
//       ? `${Number(slip.feesAmount).toLocaleString("en-IN", {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         })}₹`
//       : "";

//   return (
//     <div className="fees-slip-page">
//       {loading && <Loader />}

//       <div className="fees-slip-actions">
//         <MDBBtn
//           color="secondary"
//           size="sm"
//           onClick={() => {
//             navigate("/Fees");
//           }}
//         >
//           Back
//         </MDBBtn>
//         <MDBBtn
//           size="sm"
//           disabled={!slip}
//           onClick={() => {
//             window.print();
//           }}
//         >
//           Print
//         </MDBBtn>
//       </div>

//       <div className="fees-slip-container">
//         <div className="fees-slip-header">
//           <img src={barLogo} alt="Bar Association Dehradun" />
//           <h1>Dehradun Bar Association</h1>
//         </div>
//         <p className="fees-slip-subtitle">Fees Slip</p>
//         {/* <p className="fees-slip-date">Date: {printDate}</p> */}
//         <p className="fees-slip-date">Date: {slip.entryDate}</p>

//         {slip ? (
//           <>
//             <div className="fees-slip-details">
//               <img className="fees-slip-photo" src={photo} alt="Advocate" />
//               <div className="fees-slip-fields">
//                 <div className="fees-slip-field-row">
//                   <span className="fees-slip-field-label">Name :</span>
//                   <span>{slip.name}</span>
//                 </div>
//                 <div className="fees-slip-field-row">
//                   <span className="fees-slip-field-label">
//                     {relationshipLabel(slip.relationshipType)} :
//                   </span>
//                   <span>{slip.relativeName}</span>
//                 </div>
//                 <div className="fees-slip-field-row">
//                   <span className="fees-slip-field-label">Bar Id :</span>
//                   <span>{slip.advocateBarId}</span>
//                 </div>
//                 <div className="fees-slip-field-row">
//                   <span className="fees-slip-field-label">Mobile No :</span>
//                   <span>{slip.mobileNo}</span>
//                 </div>
//               </div>
//             </div>

//             <table className="fees-slip-table">
//               <thead>
//                 <tr>
//                   {slip.bookNo && <th>Book No</th>}
//                   {slip.srNo && <th>Serial No</th>}
//                   {slip.receiptNo && <th>Receipt No</th>}
//                   <th>Subscription Type</th>
//                   <th>Validity</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   {slip.bookNo && <td>{slip.bookNo}</td>}
//                   {slip.srNo && <td>{slip.srNo}</td>}
//                   {slip.receiptNo && <td>{slip.receiptNo}</td>}
//                   <td>{slip.memberType}</td>
//                   <td>{slip.validTill}</td>
//                   <td>{amountText}</td>
//                 </tr>
//               </tbody>
//             </table>

//             <div className="fees-slip-footer">
//               <div className="footer-block">
//                 <span className="footer-label">Signature:</span>
//                 <img
//                   className="fees-slip-signature"
//                   src={signature}
//                   alt="Signature"
//                 />
//               </div>
//               <div className="footer-block">
//                 <span className="footer-label">Fingerprint:</span>
//                 <img
//                   className="fees-slip-fingerprint"
//                   src={fingerprint}
//                   alt="Fingerprint"
//                 />
//               </div>
//             </div>
//           </>
//         ) : (
//           !loading && (
//             <p className="text-center my-5">
//               No fees record found for this bar id.
//             </p>
//           )
//         )}
//       </div>
//     </div>
//   );
// };

// export default FeesSlip;


import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MDBBtn } from "mdb-react-ui-kit";
import axiosInstance from "../utilities/apiConfig";
import Loader from "../components/Loader";
import barLogo from "../assets/images/BarAssociationDeharadunLogo.png";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import "../styles/feesSlip.css";

// entryDate comes from the fees slip api as an ISO-ish string,
// e.g. "2026-09-08T15:00:48.667" -> "08/09/2026 03:00:48 pm".
// Returns the raw value if it isn't parseable, and "" if it's missing.
const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

// Printable Membership Fees Slip. Same layout as the FeesSlip.aspx report,
// but rendered in-app with data from /LoginFees/get_fees_slip_print.
const FeesSlip = () => {
  const { barId } = useParams(); // underscore format, e.g. "UK 1486_22"
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);

  const [loading, setLoading] = useState(true);
  const [slip, setSlip] = useState(null);
  const [photo, setPhoto] = useState(dummyProfileImage);
  const [signature, setSignature] = useState(dummySignature);
  const [fingerprint, setFingerprint] = useState(dummyFingerprint);

  // e.g. "Son" / "S/O" -> "Son of"
  const relationshipLabel = (relationshipType) => {
    const value = (relationshipType || "").toLowerCase();
    if (value.includes("s")) return "Son of";
    if (value.includes("d")) return "Daughter of";
    if (value.includes("w")) return "Wife of";
    return "Relative of";
  };

  // Loads an image through the File controller view apis
  // (/File/view_photo, /File/view_signature, /File/view_fingerprint).
  // slip paths come as "Photo/abc.png" — only the file name is needed here.
  const fetchImage = async (viewApi, relativePath, setImage, fallback) => {
    const fileName = (relativePath || "").split("/").pop();
    if (!fileName) {
      setImage(fallback);
      return;
    }
    try {
      const response = await axiosInstance.get(
        `/File/${viewApi}/${encodeURIComponent(fileName)}`,
        {
          responseType: "blob",
        }
      );
      setImage(URL.createObjectURL(response.data));
    } catch (error) {
      console.error("Error fetching slip image:", relativePath, error);
      setImage(fallback);
    }
  };

  useEffect(() => {
    const fetchSlipData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/LoginFees/get_fees_slip_print/${barId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Fees slip response", response.data);

        if (response.data?.statusCode === 200 && response.data?.slip) {
          const slipData = response.data.slip;
          setSlip(slipData);
          fetchImage("view_photo", slipData.photo, setPhoto, dummyProfileImage);
          fetchImage(
            "view_signature",
            slipData.signature,
            setSignature,
            dummySignature
          );
          fetchImage(
            "view_fingerprint",
            slipData.fingerprintImage,
            setFingerprint,
            dummyFingerprint
          );
        } else {
          toast.error(response.data?.status || "Could not load fees slip");
        }
      } catch (error) {
        console.error("Error loading fees slip", error);
        if (error.response?.status === 401) {
          toast.error("Session expired. Please login again.");
        } else if (error.response?.status === 404) {
          toast.error("No fees record found for this bar id.");
        } else {
          toast.error("Could not load fees slip");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSlipData();
  }, [barId, token]);

  const amountText =
    slip?.feesAmount !== null && slip?.feesAmount !== undefined
      ? `${Number(slip.feesAmount).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}₹`
      : "";

  return (
    <div className="fees-slip-page">
      {loading && <Loader />}

      <div className="fees-slip-actions">
        <MDBBtn
          color="secondary"
          size="sm"
          onClick={() => {
            navigate("/Fees");
          }}
        >
          Back
        </MDBBtn>
        <MDBBtn
          size="sm"
          disabled={!slip}
          onClick={() => {
            window.print();
          }}
        >
          Print
        </MDBBtn>
      </div>

      <div className="fees-slip-container">
        <div className="fees-slip-header">
          <img src={barLogo} alt="Bar Association Dehradun" />
          <h1>Dehradun Bar Association</h1>
        </div>
        <p className="fees-slip-subtitle">Fees Slip</p>

        {slip ? (
          <>
            <p className="fees-slip-date">
              Date: {formatDateTime(slip.entryDate)}
            </p>

            <div className="fees-slip-details">
              <img className="fees-slip-photo" src={photo} alt="Advocate" />
              <div className="fees-slip-fields">
                <div className="fees-slip-field-row">
                  <span className="fees-slip-field-label">Name :</span>
                  <span>{slip.name}</span>
                </div>
                <div className="fees-slip-field-row">
                  <span className="fees-slip-field-label">
                    {relationshipLabel(slip.relationshipType)} :
                  </span>
                  <span>{slip.relativeName}</span>
                </div>
                <div className="fees-slip-field-row">
                  <span className="fees-slip-field-label">Bar Id :</span>
                  <span>{slip.advocateBarId}</span>
                </div>
                <div className="fees-slip-field-row">
                  <span className="fees-slip-field-label">Mobile No :</span>
                  <span>{slip.mobileNo}</span>
                </div>
              </div>
            </div>

            <table className="fees-slip-table">
              <thead>
                <tr>
                  {slip.bookNo && <th>Book No</th>}
                  {slip.srNo && <th>Serial No</th>}
                  {slip.receiptNo && <th>Receipt No</th>}
                  <th>Subscription Type</th>
                  <th>Validity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {slip.bookNo && <td>{slip.bookNo}</td>}
                  {slip.srNo && <td>{slip.srNo}</td>}
                  {slip.receiptNo && <td>{slip.receiptNo}</td>}
                  <td>{slip.memberType}</td>
                  <td>{slip.validTill}</td>
                  <td>{amountText}</td>
                </tr>
              </tbody>
            </table>

            <div className="fees-slip-footer">
              <div className="footer-block">
                <span className="footer-label">Signature:</span>
                <img
                  className="fees-slip-signature"
                  src={signature}
                  alt="Signature"
                />
              </div>
              <div className="footer-block">
                <span className="footer-label">Fingerprint:</span>
                <img
                  className="fees-slip-fingerprint"
                  src={fingerprint}
                  alt="Fingerprint"
                />
              </div>
            </div>
          </>
        ) : (
          !loading && (
            <p className="text-center my-5">
              No fees record found for this bar id.
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default FeesSlip;